import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import * as Moment from 'moment';
import { ApiUrls } from 'src/app/shared/api-urls';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { DateToFilter } from 'src/app/shared/date-filter';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { switchMap } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

class InvoicesFilter {
  /**
   * Limit start of company filter
   * i.e Items per page
   */
  itemsPerPage = 20;
  currentPage = 1;
  totalCount = 0;
  start = 0;
  active = 2;
  /**
   * Limit page length of company filter
   * page length
   */
  search = {
    filterBy: 'This Month',
    filterDate: '',
    filterType: 'invoice_date',
    // startDate: '',
    // endDate: '',
    // customstartDate: '',
    // customendDate: '',
  };
}
@Component({
  selector: 'app-expired-invoices',
  templateUrl: './expired-invoices.component.html',
  styleUrls: ['./expired-invoices.component.scss'],
})
export class ExpiredInvoicesComponent implements OnInit {
  filters = new InvoicesFilter();
  years: any = [];
  selectedDate: any = 'All';
  selectedMonth: any;
  selectedYear: any;
  companyDetails: any;
  invoiceList: any = [];
  invoiceSearchObj: any = {};
  apiDomain = environment.apiDomain;
  today = new Date();
  days_in_a_month: any;
  combinedDates: any = [];
  selectedFilterBy: any;
  thismonth: any = [];
  lastmonth: any = [];
  totalcount: any;
  constructor(
    private http: HttpClient,
    private router: Router,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    public dateTimeAdapter: DateTimeAdapter<any>
  ) {
    dateTimeAdapter.setLocale('en-IN');
  }

  ngOnInit(): void {
    this.companyDetails = JSON.parse(localStorage.getItem('company'));
    this.filters.itemsPerPage = this.companyDetails?.items_per_page;
    this.activatedRoute.queryParams.subscribe((res: any) => {
      if (res.search) {
        const dateBy = JSON.parse(res.search);
        this.filters.search.filterBy = dateBy.filterBy;
        this.filters.search.filterDate = dateBy.filterDate;
        this.selectedFilterBy = this.filters.search.filterBy;
        if (this.filters.search.filterBy == 'Custom') {
          (this.selectedFilterBy = moment(
            this.filters?.search?.filterDate[0]
          ).format('YYYY-MM-DD')),
            moment(this.filters?.search?.filterDate[1]).format('YYYY-MM-DD');
        }
      }
      // if (res.searchFilter) {
      //   const dateBy = JSON.parse(res.searchFilter)
      //   this.filters.searchFilter.name = dateBy.name;
      //   this.filters.searchFilter.code = dateBy.code;
      //   this.filters.searchFilter.sacCode = dateBy.sacCode;
      // }
    });
    // this.updateRouterParams();
    this.getInvoices();
  }

  getInvoices() {
    const queryParams: any = { filters: [] };
  
    if (this.filters.search.filterBy) {
      if (this.filters.search.filterBy === 'Custom') {
        if (this.filters.search.filterDate) {
          const filter = new DateToFilter(
            'Invoices',
            this.filters.search.filterBy,
            this.filters.search.filterDate as any,
            this.filters.search.filterType as any
          ).filter;
          if (filter) {
            queryParams.filters.push(filter);
          }
        }
      } else if (this.filters.search.filterBy !== 'All') {
        const filter = new DateToFilter(
          'Invoices',
          this.filters.search.filterBy,
          null,
          this.filters.search.filterType
        ).filter;
        if (filter) {
          queryParams.filters.push(filter);
        }
      }
    }
  
    this.selectedFilterBy = this.filters.search.filterBy;
  
    queryParams.limit_page_length = this.filters.itemsPerPage;
    queryParams.limit_start = (this.filters.currentPage - 1) * this.filters.itemsPerPage;
    queryParams.filters.push(['invoice_type', 'like', 'B2B']);
    queryParams.filters.push(['irn_generated', 'in', ['Pending', 'Error']]);
    queryParams.fields = JSON.stringify(['*']);
    queryParams.filters = JSON.stringify(queryParams.filters);
    queryParams.order_by = '`tabInvoices`.`invoice_date` desc';
  
    forkJoin({
      countApi: this.http.get(ApiUrls.invoices, {
        params: {
          fields: JSON.stringify(['count( `tabInvoices`.`name`) AS total_count']),
          filters: queryParams.filters,
        },
      }),
      resultApi: this.http.get(ApiUrls.invoices, { params: queryParams }),
    }).subscribe((res: any) => {
      if (this.filters.currentPage === 1) {
        this.invoiceList = [];
      }
  
      const [count, data] = [res?.countApi, res?.resultApi];
      this.filters.totalCount = count?.data[0]?.total_count;
  
      data.data = data?.data.map((each: any, index: any) => {
        if (each) {
          each.index = this.invoiceList.length + index + 1;
        }
        return each;
      });
  
      if (data.data) {
        if (this.filters.currentPage !== 1) {
          this.invoiceList = this.invoiceList.concat(data.data);
        } else {
          this.invoiceList = data.data;
        }
  
        // Update expiry date and filter invoices
        this.invoiceList = this.invoiceList.filter((each: any) => {
          let todayDate: any = moment(each?.invoice_date).format('YYYY-MM-DD');
          let expiryDate: any = this.companyDetails?.e_invoice_missing_start_date
            ? moment(this.companyDetails?.e_invoice_missing_start_date).format('YYYY-MM-DD')
            : null;
          // If e-invoice missing feature is enabled and todayDate >= expiryDate
          if (this.companyDetails?.e_invoice_missing_date_feature && todayDate >= expiryDate) {
            let calculatedExpiryDate = moment(
              moment(each?.invoice_date).add(this.companyDetails?.no_of_days_to_expiry, 'd')
            ).format('YYYY-MM-DD');
            
            // Add expiry date to the invoice object
            each['expiry_date'] = calculatedExpiryDate;
  
            // Return true to include this invoice in the filtered list
            return true;
          }
  
          // Return false if the invoice does not meet the criteria
          return false;
        });
      }
    });
  }
  

  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }
  getYear() {
    var currentYear = new Date().getFullYear();
    var startYear = 2022;
    for (var i = startYear; i <= currentYear; i++) {
      this.years.push(startYear++);
    }
    return this.years;
  }

  onDateFilterMonthChange() {
    try {
      this.getInvoices();
    } catch (err) {
      console.log(err);
    }
  }
  downloadReport() {
    let fromDate = '';
    let toDate = '';
    const filterBy = this.filters.search.filterBy;

    if (filterBy === 'This Month') {
      fromDate = moment().startOf('month').format('YYYY-MM-DD');
      toDate = moment().endOf('month').format('YYYY-MM-DD');
    } else if (filterBy === 'Last Month') {
      fromDate = moment()
        .subtract(1, 'months')
        .startOf('month')
        .format('YYYY-MM-DD');
      toDate = moment()
        .subtract(1, 'months')
        .endOf('month')
        .format('YYYY-MM-DD');
    } else if (filterBy === 'Last 6 Months') {
      fromDate = moment()
        .subtract(6, 'months')
        .startOf('month')
        .format('YYYY-MM-DD');
      toDate = moment().format('YYYY-MM-DD');
    } else if (filterBy === 'Custom' && this.filters.search.filterDate) {
      fromDate = moment(this.filters.search.filterDate[0]).format('YYYY-MM-DD');
      toDate = moment(this.filters.search.filterDate[1]).format('YYYY-MM-DD');
    }
    this.http
      .post(ApiUrls.report_for_invoices, {
        report_type: 'expired',
        from_date: fromDate,
        to_date: toDate,
      })
      .subscribe((res: any) => {
        if (res?.message?.success) {
          window.open(`${this.apiDomain}${res?.message?.file_path}`, '_blank');
        } else {
          this.toastr.error(res?.message?.message);
        }
      });
  }

  onDateFilterChange() {
    // this.selectedFilterBy = event;
    // console.log(this.selectedFilterBy,'event')
    this.filters.currentPage = 1;
    if (this.filters.search.filterBy == 'Custom') {
      this.filters.search.filterDate = '';
    } else {
      this.updateRouterParams();
    }
  }
  updateRouterParams(): void {
    const temp = JSON.parse(JSON.stringify(this.filters));
    temp.search = JSON.stringify(temp.search);
    this.router.navigate(['home/expired-invoices'], {
      queryParams: temp,
    });

    this.getInvoices();
  }
  checkPagination(): void {
    this.filters.currentPage = 1;
    this.updateRouterParams();
  }
  increaseItemsPerPage(res: any) {
    this.filters.itemsPerPage *= 2;
    this.filters.start = this.invoiceList.length;
    if (this.filters.itemsPerPage > this.filters.totalCount) {
      this.filters.itemsPerPage = this.filters.totalCount;
    }
    this.checkPagination();
  }
}

